<template>
  <div class="col-sm-12 combat-log">
    <ul>
      <transition-group
        name="slideY"
        @enter="slideYIn"
        @leave="slideYOut"
        mode="out-in"
      >
        <li v-for="logRow in combatLog" :class="logRow.type" :key="logRow.id">
          {{ logRow.descr }}: {{ logRow.value }}
        </li>
      </transition-group>
    </ul>
  </div>
</template>

<script>
import { transitions } from "../../../animations/mixins/TransitionMixin.js";

export default {
  name: "CombatLog",
  props: {
    combatLog: {
      type: Array,
      required: true
    }
  },
  mixins: [transitions]
};
</script>

<style lang="scss" scoped>
.slideY-leave-active {
  position: absolute;
}

.slideY-move {
  transition: transform 1s;
}
</style>